<button
  class="group flex w-full flex-row flex-nowrap items-center justify-center gap-2 rounded-2xl pl-4 pr-4"
  [class]="
    (type() === 'primary'
      ? 'bg-[#CA2514] hover:bg-[#B52112] focus:bg-[#CA2514] active:bg-[#9E1D0F] disabled:bg-[#D0D2D8]'
      : type() === 'secondary'
        ? 'border border-[#515561] hover:bg-[#f0f0f0] focus:bg-transparent active:bg-[#2E3138] disabled:bg-[#D0D2D8]'
        : 'bg-[#E6E8EB] hover:bg-[#d4d6d9] focus:bg-[#E6E8EB] active:bg-[#2E3138] disabled:bg-[#D0D2D8]') +
    ' ' +
    (size() === 'default' ? 'h-[48px] pb-3 pt-3' : 'h-fit pb-2 pt-2')
  "
  [disabled]="disabled()"
  (click)="onClick($event)"
>
  @if (leftIcon()) {
    <svg-icon
      [src]="leftIcon()"
      [svgClass]="
        (type() === 'primary'
          ? 'fill-white group-hover:fill-white group-focus:fill-white group-active:fill-white group-disabled:fill-white'
          : 'fill-[#515561] group-hover:fill-[#515561] group-focus:fill-[#515561] group-active:fill-white group-disabled:fill-white') +
        ' w-[24px] h-[24px]'
      "
    ></svg-icon>
  }

  <div
    class="text-center font-semibold tracking-normal"
    [class]="
      (type() === 'primary'
        ? 'text-white group-hover:text-white group-focus:text-white group-active:text-white group-disabled:text-white'
        : 'text-[#515561] group-hover:text-[#515561] group-focus:text-[#515561] group-active:text-white group-disabled:text-white') +
      ' ' +
      (size() === 'default'
        ? 'text-base leading-[22.4px]'
        : 'text-sm leading-[19.6px]')
    "
  >
    {{ label() }}
  </div>

  @if (rightIcon()) {
    <svg-icon
      [src]="rightIcon()"
      [svgClass]="
        (type() === 'primary'
          ? 'fill-white group-hover:fill-white group-focus:fill-white group-active:fill-white group-disabled:fill-white'
          : 'fill-[#515561] group-hover:fill-[#515561] group-focus:fill-[#515561] group-active:fill-white group-disabled:fill-white') +
        ' w-[24px] h-[24px]'
      "
    ></svg-icon>
  }
</button>
